import React, {useState, useEffect} from 'react'
import {useNavigate} from 'react-router-dom'
import Colors from '../../config/colors'
import Styles from "./Styles/CustomNavBar.module.scss";
import {auth} from '../../services/firebase'
import {useDispatch, useSelector} from 'react-redux'
import userSlice, {addUser} from '../../redux/slices/userSlice'
import {useLocation} from 'react-router-dom'
import Tooltip from '@mui/material/Tooltip';
import Logout from '../../assets/logos/logout.png'

import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';
import SettingsIcon from '@mui/icons-material/Settings';
import ExpandIcon from '../../assets/logos/expand.png'
import Config from '../../config'
import {API_CALL_STATUS} from "../../metadata/enums";
import NotificationsActiveIcon from '@mui/icons-material/NotificationsActive';
import MoveToInboxIcon from '@mui/icons-material/MoveToInbox';
import SearchIcon from '@mui/icons-material/Search';
import {updateActiveUnderwritingId} from "../../redux/slices/workOrdersSlice";

const LINKS = [
  {label: 'Work-Orders', id: 1},
	{label: 'ATTOM Search', id: 2},
	{label: 'Settings', id: 3},
]

const CustomNavBar = ({accessCallback}) => {
  let navigate = useNavigate()
  let dispatch = useDispatch()
  const location = useLocation();
  let path = location.pathname
  const userState = useSelector(state => {
    return state.user
  })
	const activeUnderwritingId = useSelector(state => state.workOrders.active_underwriting_id)
  const mongoUser = useSelector(state => state.user?.mongoUser)

  const [activeItemId, setActiveItemId] = useState(1)
  const [collapsed, setCollapsed] = useState(true)


  useEffect(() => {
    if (path.includes('work'))
      setActiveItemId(1)
    else if (path.includes('attom'))
      setActiveItemId(2)
	  else if (path.includes('settings'))
	    setActiveItemId(3)

  }, [path, mongoUser])

  const onSignOutClicked = () => {
    dispatch(addUser(null))
    auth.signOut();
  }

  const getIcon = ({id}) => {
		switch(id) {
			case 1:
				return <FormatListBulletedIcon style={{color: activeItemId === id? 'white' : 'gray', marginLeft: 10}} />
			case 2:
				return <SearchIcon style={{color: activeItemId === id? 'white' : 'gray', marginLeft: 10}} />
			case 3:
				return <SettingsIcon style={{color: activeItemId === id? 'white' : 'gray', marginLeft: 10}} />
      default:
		}
  }

  const onItemSelect = (itemId) => {
    setActiveItemId(itemId)

    switch (itemId) {
      case 1:
				if(activeUnderwritingId)
					navigate('/home/underwriting-details')
	      else
          navigate('/home/work-orders')
        break;
	    case 2:
		    navigate('/home/attom-search')
		    break;
      case 3:
        navigate('/home/settings')
        break;
      default:
    }
  }

  const renderLinks = () => {
    let elements = []
		elements = LINKS.map((link, index) => {
			return (
				<div
					style={{
						borderRight: activeItemId === link.id ? `5px solid white` : '',
						marginTop: 5
					}}
					key={index.toString()}
					onClick={() => onItemSelect(link.id)}
					className={Styles.linkRow}>
					{
						collapsed ?
							<Tooltip title={link.label}>
								{getIcon(link)}
							</Tooltip>
							:
							getIcon(link)
					}
					{!collapsed &&
						<p
							style={
								{
									color: activeItemId !== link.id ? 'gray' : 'white',
									marginLeft: 20
								}}>
							{link.label}
						</p>
					}
				</div>
			)
		})


    return (
      <div style={{
        display: 'flex',
        flexDirection: "column",
        justifyContent: "center",
        width: '100%',
        alignItems: 'center',
        marginTop: 20
      }}>
        {elements}
      </div>
    )
  }

  const renderFullContent = () => {
    return (
      <div style={{width: '100%'}}>
        <div style={{
          display: 'flex',
          flexDirection: "row",
          alignItems: 'center',
          justifyContent: 'space-evenly',
          width: '100%',
          marginTop: 20
        }}>
					<label style={{fontSize: 20, fontWeight: 'bold', letterSpacing: '.3rem'}}>LendCo</label>

          <img
            onClick={() => setCollapsed(true)}
            src={ExpandIcon} style={{height: 17, width: 17, cursor: 'pointer'}} alt={'missing'}/>
        </div>
        {renderLinks()}


        <div
          style={{position: 'absolute', bottom: 20, padding: '0 20px'}}>

          <div
            onClick={onSignOutClicked}
            className={Styles.linkRow}>
            <img
              src={Logout} style={{height: 18, width: 18}}/>
            <label
              style={{color: Colors.tertiaryTextColor, marginLeft: 20, cursor: 'pointer'}}>
              Logout
            </label>
          </div>
        </div>
      </div>
    )
  }

  const renderCollapsedContent = () => {
    return (
      <div style={{width: '100%'}}>
        <div style={{
          width: '100%',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          marginTop: 20
        }}>
          <img
            onClick={() => setCollapsed(false)}
            src={ExpandIcon} style={{height: 17, width: 17, cursor: 'pointer'}}/>
        </div>

        {renderLinks()}
        <div style={{position: 'absolute', bottom: 20, padding: '0px 4px', cursor: 'pointer'}}>

          <Tooltip title={'Sign Out'}>
            <img
              onClick={onSignOutClicked}
              src={Logout} style={{height: 18, width: 18, marginLeft: 10}}></img>
          </Tooltip>
        </div>
      </div>
    )
  }

  return (
    <div
      className={Styles.navBarContainer}
      style={{width: collapsed ? 50 : 260}}

    >
      {
        collapsed ?
          renderCollapsedContent()
          :
          renderFullContent()
      }
    </div>
  )
}

export default CustomNavBar
